/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "./style.scss";
import { PostApi } from "../services/auth";
import { isValid } from "../services/utils";
import { Button, CustomInput } from "src/Components/customInput";

import { ReactComponent as Add } from "src/Assets/Icons/add.svg";
import showToast from "../services/toastyService";

export default function Usuarios({ darkMode }) {
  const [vendas, setVendas] = useState([]);

  const [showDetalhes, setShowDetalhes] = useState(false);

  const [showPopup, setShowpoup] = useState(false);
  const [novoUsuario, setNovoUsuario] = useState({});
  const [camposVazios, setCamposVazios] = useState([]);

  const [errorMsg, setErrorMsg] = useState("");

  function HandleAdd() {
    const newData = {
      email: novoUsuario.email,
      password: novoUsuario.password,
    };

    const campos_vazios = Object.entries(newData)
      .filter(
        ([_, valor]) => valor === null || valor === undefined || valor === ""
      )
      .map(([campo]) => campo);

    setCamposVazios(campos_vazios);

    if (campos_vazios.length > 0) {
      return;
    }

    PostApi("usuarios", newData)
      .then(() => {
        showToast("success", "Usuário Adicionado");
        setShowpoup(false);
      })
      .catch((error) => {
        const msg =
          error?.response?.data?.message ||
          error.message ||
          "Erro desconhecido";
        setErrorMsg(msg);
      });
  }

  return (
    <div className="Usuarios">
      <button
        className={`-popupFade ${showPopup ? "" : "hide"}`}
        onClick={() => setShowpoup(false)}
      />

      <div className="-popup">
        <h3> Novo Usuário </h3>

        <div className="content">
          <CustomInput
            Class={
              camposVazios?.includes("email") && !isValid(novoUsuario.email)
                ? "alert"
                : ""
            }
            Style="Default"
            Type="text"
            Placeholder="Email"
            OnChange={(e) =>
              setNovoUsuario((prev) => ({
                ...prev,
                email: e.target.value,
              }))
            }
          />

          <CustomInput
            Class={
              camposVazios?.includes("password") &&
              !isValid(novoUsuario.password)
                ? "alert"
                : ""
            }
            Style="Default"
            Type="password"
            Placeholder="Senha"
            OnChange={(e) =>
              setNovoUsuario((prev) => ({
                ...prev,
                password: e.target.value,
              }))
            }
          />
        </div>

        {camposVazios.length > 1 && <h4> Preencha Todos os campos. </h4>}
        {errorMsg && <h4> {errorMsg} </h4>}

        <Button ClassName="icon" OnClick={() => HandleAdd()}>
          <Add /> Adicionar
        </Button>
      </div>

      <button
        className={`-popupFade ${showDetalhes ? "" : "hide"}`}
        onClick={() => setShowDetalhes(false)}
      />
    </div>
  );
}
